/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';

import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';

import { EventService } from '../../services/event.service';
import { SessionService } from '../../services/session2.service';

@Component({
  selector: 'global-update',
  templateUrl: './global-update.component.html',
  styleUrls: ['./global-update.component.scss']
})
export class GlobalUpdateComponent implements OnInit {

  constructor(private eventService: EventService,
              private sessionService: SessionService,
              private modalService: BsModalService) {
    this.eventService.versionChange$.subscribe(version => this.onVersionChange(version));
  }

  ngOnInit() {
  }

  /**
   * Detects a version change and reloads the app
   * @param version
   */
  onVersionChange(version: string) {
    this.modalService.show(AlertDialogComponent, Object.assign({}, {
      initialState: {
        message: `We've released a new version of Drift Email! Your browser will reload to make sure you have the latest goodness.`,
        confirmBtn: 'Ok'
      }
    }));

    this.modalService.onHide.subscribe(
      result => {
        this.reload();
      }
    );
  }

  /**
   * Reload session in case things have changed with this deploy
   */
  private reload() {
    this.sessionService.getSession(true).subscribe(
      (result: any) => {
        location.reload();
      },
      error => {
        location.reload();
      }
    );
  }

}



// WEBPACK FOOTER //
// ./client/app/global/global-update/global-update.component.ts